/* 
This source is part of the Akeria  and is
copyrighted by Uniphore system software limited.

All rights reserved.  No part of this work may be reproduced, stored in a
retrieval system, adopted or transmitted in any form or by any means,
electronic, mechanical, photographic, graphic, optic recording or otherwise,
translated in any language or computer language, without the prior written
permission of  Uniphore system software limited.

Uniphore system software limited.
Vaishnavi Silicon Terrace, B- Block, 
3rd & 4th floor, Hosur Rd, 
Adugodi, Bengaluru, Karnataka 560095

India

Copyright 2019 Uniphore system software limited.

Modification History

Date          Version                    Author                        Description
----------   -----------        --------------- ----------------     ------------------------
01 07 2018    1                   Professional service Initial version     
01-11-2019    1.1                     Gokulakannan                        developed nominee page
05-12-2019    1.2                    Pappuraj                              Date picker added 
*/

import { Component, OnInit } from '@angular/core';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { RestapiService } from 'src/app/service/api/restapi.service';
import { FormBuilder, Validators } from '@angular/forms';
import * as moment from 'moment';
import { AlertController, NavController, MenuController, Platform } from '@ionic/angular';
import { ActionlistenService } from 'src/app/service/actionlisten.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-nominee',
  templateUrl: './nominee.page.html',
  styleUrls: ['./nominee.page.scss'],
})
export class NomineePage implements OnInit {

  headingtitle: any;
  langcontext: any;
  // NomineeList: any;
  AllExistingNominee: any;
  addNomineeFlg: any;
  AddNominee: any;
  SaluationList: any;
  RelationList: any;
  RelationgenList: any;
  CountryList: any;
  NationalList: any;
  NomineeData: any;
  formsubmitted: any;
  NomineeForm: any;
  validPin: any;
  UpdateNomineeList: any;
  AddedNominees: any;
  TotalNominees: any;
  existValue: any;
  EditIndex: any;
  AppointeeFlg: any;
  BackupNominee: any;
  appointelangContext: any;
  maxDate: any;
  nomieesubmitted: any;
  percentageempty: any;
  totalpercentage: any;
  pinflg: any = 0;
  alertFlg: any = 0;
  btnactiveflg: boolean = false;
  

  constructor(public cmndef: CommonDefinitionService, public _DomSanitizer: DomSanitizer, public platform: Platform, public menuCtrl: MenuController, public actionVal: ActionlistenService, public navctrl: NavController, public formBuilder: FormBuilder, public alertCtrl: AlertController, public cmndecl: CommonDeclarationService, public api: RestapiService) {
    this.AllExistingNominee = [];
    this.cmndecl.BcknomineeList = [];
    this.TotalNominees = [];
    this.UpdateNomineeList = [];
    this.AppointeeFlg = false;
    this.percentageempty = false;
    this.totalpercentage = false;
    this.AddedNominees = [];
    this.EditIndex = 99999999;
    this.NomineeData = {}
    this.AddNominee = "No";
    this.existValue = "No";
    this.addNomineeFlg = false;
    this.nomieesubmitted = false;
    this.maxDate = moment(new Date()).add('-18', 'years').format('YYYY-MM-DD');
    console.log(this.maxDate)
    if (this.cmndecl.LanguageJson) {
      this.langcontext = this.cmndecl.LanguageJson.pages[0]['nominee'];
      this.appointelangContext = this.cmndecl.LanguageJson.pages[0]['addappointee'];
    } else {
      this.cmndecl.LanguageJson = JSON.parse(localStorage.languageJson);
      this.langcontext = this.cmndecl.LanguageJson['pages'][0].nominee;
      this.appointelangContext = this.cmndecl.LanguageJson['pages'][0].addappointee;
    }
    this.headingtitle = this.langcontext.heading.text;
    this.getNominee();
    this.setDropdownList();
    this.setValue();
  }

  ngOnInit() {
  }

  ionViewWillEnter() {
    this.menuCtrl.swipeEnable(false);
  }

  Addnominee() {
    console.log(this.AddNominee);
    this.cmndecl.Actionsheetenable = true;
    this.addNomineeFlg = true;
  }

  getNominee() {
    let req: any;
    let res: any;
    let nomineName: any;
    let nominee: any
    req = {
      "userChatSessionID": localStorage.userChatSessionId,
      "userSessionID": localStorage.userSessionID
    };
    this.api.postapi("getNomineeDetails", req).then(data => {
      res = data;
      if (res.nominee != "") {
        nomineName = res.nominee.split('&lt;br&gt;');
        for (let i = 0; i < nomineName.length; i++) {
          nominee = nomineName[i].split("-");
          if (nominee.length > 1) {
            let dm = {
              Firstname: nominee[0],
              percentage: parseInt(nominee[1].substring(0, nominee[1].length - 1)),
              Relation: nominee[2],
              status: "exist",
              set: "No"
            };
            console.log(dm)
            this.AllExistingNominee.push(dm);
          }
        }
        this.cmndecl.BcknomineeList = JSON.stringify(this.AllExistingNominee);
      } else {
        this.cmndef.presentAlert("Nominee Details", "No Records Found", "nominee");
      }
      console.log(this.AllExistingNominee)
    }, err => {
      console.log(err);
      this.cmndef.presentAlert("Nominee Details", "No Records Found", "nominee")
    });
  }

  closePopup() {
    this.AddNominee = "No"
    if (this.AppointeeFlg) {
      this.AppointeeFlg = false;
      this.formsubmitted = false;
      this.NomineeData = this.BackupNominee;
      this.NomineeData.DOB = "";
    } else {
      this.cmndecl.Actionsheetenable = false;
      this.addNomineeFlg = false;
      this.formsubmitted = false;
      this.setValue();
    }
  }

  setValue() {
    if (this.AppointeeFlg) {
      this.NomineeData = {
        "Salutation": "",
        "Firstname": "",
        "Surname": "",
        "DOB": "",
        "gender": "",
        "marital": "",
        "Relation": "",
        "Nationality": "",
        "Resident": "",
        "address1": "",
        "Country": "",
        "pincode": "",
        "city": "",
        "state": ""
      };
    } else {
      this.NomineeData = {
        "Salutation": "",
        "Firstname": "",
        "Surname": "",
        "DOB": "",
        "gender": "",
        "marital": "",
        "Relation": "",
        "Nationality": "",
        "Resident": "",
        "address1": "",
        "Country": "",
        "pincode": "",
        "city": "",
        "state": "",
        "percentage": "",
        "set": "no",
        "status": "new",
        "subtouch": true,
        "nomineeindex": 0
      };
    }
    this.NomineeForm = [];
    this.NomineeForm = this.formBuilder.group({
      Salutation: ['', Validators.required],
      Firstname: ['', Validators.required],
      Surname: ['', Validators.required],
      DOB: ['', Validators.required],
      gender: ['', Validators.required],
      marital: ['', Validators.required],
      Relation: ['', Validators.required],
      Nationality: ['', Validators.required],
      Resident: ['', Validators.required],
      address1: ['', Validators.required],
      Country: ['', Validators.required],
      pincode: ['', Validators.required],
      city: ['', Validators.required],
      state: ['', Validators.required]
    });
  }

  async setDropdownList() {
    let res : any;

    await this.cmndecl.getstoreProcess("nomineesalgen").then(data=>{
      res = data
      this.SaluationList = res;
    });

    await this.cmndecl.getstoreProcess("nomineeNationality").then(data=>{
      res = data
      this.NationalList = (res).split(",");
    });

    await this.cmndecl.getstoreProcess("nomineeRelation").then(data=>{
      res = data
      this.RelationList = res;
    });

    await this.cmndecl.getstoreProcess("nomineerelationgen").then(data=>{
      res = data
      this.RelationgenList = res;
    });

    await this.cmndecl.getstoreProcess("nomineeCountry").then(data=>{
      res = data
      this.CountryList = (res).split(",");
    });
  }

  checkpincode() {
    let res: any;
    let req: any;
    if (this.pinflg == 0) {
      this.pinflg = 1;
      if ((this.NomineeData.Country).trim() == "India") {
        console.log(this.NomineeData.pincode.length);
        if (this.NomineeData.pincode.length > 5) {
          req = {
            pinCode: this.NomineeData.pincode
          }
          this.api.postapi("verifyPincode", req).then(data => {
            res = data;
            if (res.message == 'Valid Pin Code')
              this.validPin = true;
            else
              this.validPin = false;
            this.pinflg = 0;
          }, err => {
            this.pinflg = 0;
            console.log(err);
          })
        } else {
          this.pinflg = 0;
        }
      } else {
        this.pinflg = 0;
        this.validPin = false;
      }
    }
  }

  AddExistNominee() {
    this.UpdateNomineeList = [];
    let demo: any = JSON.parse(this.cmndecl.BcknomineeList);
    for (let i = 0; i < this.AllExistingNominee.length; i++) {
      this.AllExistingNominee[i].percentage = demo[i].percentage;
    }
    console.log(this.AllExistingNominee);
    setTimeout(()=>{
      for (let i = 0; i < this.AllExistingNominee.length; i++) {
        console.log(this.AllExistingNominee[i].set);
        if (this.AllExistingNominee[i].set == 'Yes') {
          this.UpdateNomineeList.push(this.AllExistingNominee[i]);
        }
      }
      this.TotalNomineList();
    },100);
  }

  AddNomineeList() {
    let dobdate: any;
    if (this.cmndecl.cordovaSupport) {
      dobdate = this.NomineeData.DOB;
    }
    else {
      dobdate = moment(this.NomineeData.DOB).format('DD/MM/YYYY');
    }
    if (this.NomineeForm.valid && (this.validPin || (this.NomineeData.Country).trim() != "India")) {
      if (this.EditIndex != 99999999)
        this.AddedNominees[this.EditIndex] = this.NomineeData;
      else {
        this.NomineeData.nomineeindex = this.AddedNominees.length + 1;
        this.NomineeData.DOB = dobdate;
        this.AddedNominees.push(this.NomineeData);
      }
      this.AddNominee = "No";
      this.EditIndex = 99999999;
      this.formsubmitted = false;
      this.addNomineeFlg = false;
      this.cmndecl.Actionsheetenable = false;
      this.setValue();
      this.TotalNomineList();
    }
  }

  TotalNomineList() {
    this.TotalNominees = [];
    for (let i = 0; i < this.UpdateNomineeList.length; i++)
      this.TotalNominees.push(this.UpdateNomineeList[i])
    for (let i = 0; i < this.AddedNominees.length; i++)
      this.TotalNominees.push(this.AddedNominees[i]);

    this.TotalpercentageCalulcation();
  }

  EditNominee(idx: any) {
    this.NomineeData = this.AddedNominees[idx];
    this.addNomineeFlg = true;
    this.cmndecl.Actionsheetenable = true;
    this.formsubmitted = false;
    this.EditIndex = idx;
    this.checkpincode();
  }

  deleteNominee(idx: any) {
    this.AddedNominees.splice(idx, 1);
    this.formsubmitted = false;
    this.TotalNomineList();
  }

  addappointee() {
    var selectedDate = this.NomineeData.DOB;
    if(this.cmndecl.BrowserBuild == 1){
      selectedDate = selectedDate.substring(0,10);
      console.log(selectedDate);
      if(selectedDate.indexOf("-")!= -1){
        var splitvar = selectedDate.split("-");
        selectedDate = splitvar[2]+"/"+splitvar[1]+"/"+splitvar[0];
        console.log(selectedDate)
        this.NomineeData.DOB = splitvar[1]+"/"+splitvar[2]+"/"+splitvar[0];
      }
    }
    var mdate = selectedDate.toString();
    var dayThen = parseInt(mdate.substring(0, 2), 10);
    var monthThen = parseInt(mdate.substring(3, 5), 10);
    var yearThen = parseInt(mdate.substring(6, 10), 10);
    console.log(this.getAge({ year: yearThen, momonthnth: monthThen, day: dayThen }))
    if (this.getAge({ year: yearThen, momonthnth: monthThen, day: dayThen }) < 18) {
      this.ShowAlertAppointee();
    }
  }

  async ShowAlertAppointee() {
    if(this.alertFlg == 0){
      this.alertFlg =1;
      this.cmndecl.Actionsheetenable = true;
      const alert = await this.alertCtrl.create({
        header: "",
        subHeader: "",
        message: this.langcontext.agecondtion.label,
        backdropDismiss: false,
        buttons: [
          {
            text: this.langcontext.yes.label,
            cssClass: 'yesbutton',
            handler: (blah) => {
              this.AppointeeFlg = true;
              this.alertFlg =0;
              this.BackupNominee = this.NomineeData;
              this.setValue();
              this.formsubmitted = false;
              var elmnt = document.getElementById("nompopup");
              elmnt.scrollTo({ top: 0, behavior: 'smooth' });
            }
          },
          {
            text: this.langcontext.no.label,
            cssClass: 'secondary',
            handler: (blah) => {
              this.AppointeeFlg = false;
              this.alertFlg =0;
              console.log("cancel")
              this.NomineeData.DOB = "";
            }
          }
        ]
      });
      await alert.present();
    }
    
  }

  showDatepicker(flag) {
    var date = new Date().getDate();
    var month = (new Date().getMonth() + 1);
    console.log(date);
    console.log(month)

    if (flag == 'nominee') {
      if (this.NomineeData.DOB == undefined || this.NomineeData.DOB == null || this.NomineeData.DOB == "") {
        var year = moment(new Date()).add('-18', 'years').format('YYYY')
        let fulldate = new Date('01/01/2001');
        let mdte = new Date();
        this.cmndef.showdatePicker(fulldate, "", mdte).then(data => {
          this.NomineeData.DOB = data;
          if(this.NomineeData.appointeedata != undefined && this.NomineeData.appointeedata != "" && this.NomineeData.appointeedata != null){
            this.NomineeData.appointeedata = "";
          }
        }, err => {
          console.log(err);
        });
      }
      else {
        let split = this.NomineeData.DOB.split("/");
        let sdate = split[1] + "/" + split[0] + "/" + split[2]
        let d = new Date(sdate);
        let mdte = new Date();
        this.cmndef.showdatePicker(d, "", mdte).then(data => {
          this.NomineeData.DOB = data;
          if(this.NomineeData.appointeedata != undefined && this.NomineeData.appointeedata != "" && this.NomineeData.appointeedata != null){
            this.NomineeData.appointeedata = "";
          }
        }, err => {
          console.log(err);
        });
      }
    } else {
      if (this.NomineeData.DOB == undefined || this.NomineeData.DOB == null || this.NomineeData.DOB == "") {
        var year = moment(new Date()).add('-18', 'years').format('YYYY');
        let fulldate = new Date(month + '/' + date + '/' + year);
        let mdte = new Date();
        this.cmndef.showdatePicker(mdte, "", fulldate).then((data: any) => {
          let dateSplit = String(data).split("/");
          let demo = dateSplit[2];
          if(Number(year) < Number(demo))
            this.NomineeData.DOB = moment(new Date(dateSplit[1] + "/" + dateSplit[0] + "/" + dateSplit[2])).add('-18', 'years').format('DD/MM/YYYY');
          else
          this.NomineeData.DOB = data;
        }, err => {
          console.log(err);
        });
      }
      else {
        let split = this.NomineeData.DOB.split("/");
        let sdate = split[1] + "/" + split[0] + "/" + split[2]
        let d = new Date(sdate);
        var year = moment(new Date()).add('-18', 'years').format('YYYY')
        let fulldate = new Date(month + '/' + date + '/' + year);
        this.cmndef.showdatePicker(d, "", fulldate).then(data => {
          this.NomineeData.DOB = data;
        }, err => {
          console.log(err);
        });

      }
    }
  }

  async AddappointeeList() {
    if (this.NomineeForm.valid && (this.validPin || (this.NomineeData.Country).trim() != "India")) {
      this.BackupNominee.appointeedata = this.NomineeData;
      this.formsubmitted = false;
      this.NomineeData = this.BackupNominee;
      this.AppointeeFlg = false;
      console.log(this.NomineeData);
    }
  }

  TotalpercentageCalulcation() {
    let Total: any = 0;
    this.percentageempty = false;
    for (let i = 0; i < this.TotalNominees.length; i++) {
      if (this.TotalNominees[i].percentage == "" || this.TotalNominees[i].percentage == undefined || this.TotalNominees[i].percentage == 0)
        this.percentageempty = true;
      Total = Total + parseFloat(this.TotalNominees[i].percentage)
    }

    if (Total.toFixed(2) != 100)
      this.totalpercentage = true;
    else
      this.totalpercentage = false;
  }

  getAge(date) {
    let curDate = new Date(),
      now = {
        year: curDate.getUTCFullYear(),
        month: curDate.getUTCMonth() + 1,
        day: curDate.getUTCDate()
      },
      diff = now.year % date.year;
    if (now.month < date.month ||
      now.month === date.month && now.day < date.day) {
      diff -= 1;
    }
    return diff;

  }


  Updatenominee() {
    let res: any;
    let req: any;
    let deleteArray: any = [];
    let flg = 1;
    for (let i = 0; i < this.TotalNominees.length; i++) {
      if (this.TotalNominees[i].percentage == "" || this.TotalNominees[i].percentage == undefined || this.TotalNominees[i].percentage == 0)
        return;
    }

    if (!this.totalpercentage && this.TotalNominees.length > 0) {
      this.cmndef.loaderstart();
      if (this.UpdateNomineeList.length == 0) {
        deleteArray = this.AllExistingNominee;
      } else if (this.UpdateNomineeList.length == this.AllExistingNominee.length)
        deleteArray = [];
      else {
        for (let i = 0; i < this.AllExistingNominee.length; i++) {
          flg = 1;
          for (let j = 0; j < this.UpdateNomineeList.length; j++) {
            if (this.AllExistingNominee[i].Firstname == this.UpdateNomineeList[j].Firstname) {
              flg = 0;
              break;
            }
          }
          if (flg == 1) {
            deleteArray.push(this.AllExistingNominee[i]);
          }
        }
      }
      for (let i = 0; i < this.AddedNominees.length; i++) {
        this.AddedNominees[i]["percentage"] = Number(this.AddedNominees[i]["percentage"]);
      }
      req = {
        nomineeDetails: {
          delete: deleteArray,
          existing: this.UpdateNomineeList,
          new: this.AddedNominees,
        },
        actionType: "NOMINEE_UPDATE",
        userChatSessionID: localStorage.userChatSessionId,
        userSessionID: localStorage.userSessionID
      }

      this.api.clickenventcap("submit_"+this.cmndef.TrakcerFromValue[this.cmndef.router.url]);
      this.api.postapi("akeiraVAAction", req).then(data => {
        console.log(data);
        res = data;
        this.cmndef.loaderend();
        this.cmndecl.TamlismaJson = res["chatResp"][0];
        sessionStorage.CurrentPage = "/va/chat";
        this.navctrl.navigateRoot("/va/chat");
      }, err => {
        console.log(err);
        this.cmndef.loaderend();
      })
    } else {
      this.TotalpercentageCalulcation();
    }
  }

  Validatation(flg: any) {
    console.log(flg);
    if (flg == "firstname") {
      console.log(this.NomineeData.Firstname)
      this.NomineeData.Firstname = this.NomineeData.Firstname.replace(/[^a-zA-Z ]+/g, '');
    } else if (flg == "Surname") {
      console.log(this.NomineeData.Surname)
      this.NomineeData.Surname = this.NomineeData.Surname.replace(/[^a-zA-Z ]+/g, '');
    } else if (flg == "city") {
      console.log(this.NomineeData.city)
      this.NomineeData.city = this.NomineeData.city.replace(/[^a-zA-Z ]+/g, '');
    } else if (flg == "state") {
      console.log(this.NomineeData.state)
      this.NomineeData.state = this.NomineeData.state.replace(/[^a-zA-Z ]+/g, '');
    } else if (flg == "pincode") {
      console.log(this.NomineeData.Firstname)
      this.NomineeData.pincode = this.NomineeData.pincode.replace(/[^0-9]+/g, '');
    }
  }

  Validpercent(idx: any) {
    if (this.TotalNominees[idx].percentage > 100) {
      var newval = String(this.TotalNominees[idx].percentage);
      newval = newval.substring(0, newval.length - 1)
      this.TotalNominees[idx].percentage = newval;
    }
    var text = String(this.TotalNominees[idx].percentage);
    var ex = /^(\d+(\.\d{0,2})?|\.?\d{1,2})$/;
    if (ex.test(text) == false) {
      text = text.substring(0, text.length - 1);
    }
    this.TotalNominees[idx].percentage = text;
  }

  vldnomineedetails(){
    if(this.AddedNominees.length == 0 && this.UpdateNomineeList.length == this.AllExistingNominee.length){
      let demo: any = JSON.parse(this.cmndecl.BcknomineeList);
      for(let i=0;i<this.UpdateNomineeList.length;i++){
        if(this.UpdateNomineeList[i].percentage != demo[i].percentage){
          return true;
          break;
        }
      }
    }else
      return true;
  }


}
